// Hands an upload from the create-menu page to the import screen of the menu it just created
// (File objects can't go through the URL). Kept in memory only: a reload simply starts the import fresh.
let pending = null

export function setPendingImport(menuId, files, importStyles) {
  pending = { menuId: String(menuId), files, importStyles }
}

// The pending upload for this menu, once; null if there isn't one.
export function takePendingImport(menuId) {
  if (!pending || pending.menuId !== String(menuId)) {
    return null
  }
  const upload = pending
  pending = null
  return upload
}
